import React, { useState } from 'react';
import {
    Button,
    Typography,
    Stack,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    Box,
    Slide,
    Divider,
    Avatar,
    Select,
    MenuItem,
    IconButton,
} from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { ArrowBack } from '@mui/icons-material';
import { APP_CONFIG } from '../../../../../config/app.config';
import { useUser } from '@shared/hooks/useUser';

interface RequestConnectorFormProps {
    onClose: () => void;
    onBack: () => void;
}



const RequestConnectorForm: React.FC<RequestConnectorFormProps> = ({
    onClose,
    onBack,
}) => {
    const [form, setForm] = useState({
        name: '',
        reason: '',
        connectorType: ''
    });

    const { user } = useUser();

    const handleClose = () => {
        setForm({ name: '', reason: '', connectorType: '' });
        onClose();
    };

    const handleEmailRequest = () => {
        const subject = encodeURIComponent('New Connector Request - JustStock');
        const body = encodeURIComponent(
            `Hi JustStock team,

I would like to request a new connector for the following application/datasource:

Application/Datasource: ${form.name || '[Please specify]'}
Type: ${form.connectorType || '[Please specify]'}
Reason: ${form.reason || '[Please specify]'}

Best regards,
${user?.name}`
        );

        const mailtoLink = `mailto:hello@juststock.ai?subject=${subject}&body=${body}`;
        window.open(mailtoLink, '_blank');

        handleClose();
    };

    return (
        <>
            <DialogHeader>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center">
                        <IconButton onClick={onBack} color="inherit">
                            <ArrowBack />
                        </IconButton>

                        <Typography variant="h6" component="div">
                            Request a new connector
                        </Typography>
                    </Stack>
                </Stack>
            </DialogHeader>

            <DialogContent sx={{ flex: 1, overflow: 'auto' }}>
                <Stack gap={3}>
                    <Box>
                        <Typography variant="h6" color="text.primary">
                            Missing a connector?
                        </Typography>
                        <Typography variant="subtitle2" color="text.secondary">
                            Request a new connector and our team will get back to you shortly.
                        </Typography>
                    </Box>

                    <Divider />

                    <TextField
                        label="What application or datasource do you want to connect to"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        fullWidth
                        required
                    />

                    <TextField
                        label="Why do you need this connector?"
                        value={form.reason}
                        onChange={(e) => setForm({ ...form, reason: e.target.value })}
                        fullWidth
                    />


                    <Stack gap={1}>

                        <Typography variant="subtitle2" color="text.secondary"> What type of application is it</Typography>

                        <Select
                            placeholder="Select a type"
                            value={form.connectorType}
                            onChange={(e) => setForm({ ...form, connectorType: e.target.value })}
                            fullWidth
                            required
                        >
                            <MenuItem value="marketplace">Marketplace</MenuItem>
                            <MenuItem value="wmw">Warehouse Management System</MenuItem>
                            <MenuItem value="erp">ERP</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                        </Select>
                    </Stack>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'flex-end', borderTop: '1px solid', borderColor: APP_CONFIG.ui.theme.colors.border, position: 'absolute', bottom: 0, left: 0, right: 0 }}>
                <Button onClick={handleEmailRequest} variant="contained">
                    Send request by email
                </Button>
            </DialogActions>
        </>
    );
};

export default RequestConnectorForm; 